<template>
  <div class="room-picture--wrapper">
    <div class="rp-content">
      <div class="rp-main-picture" :style="mainPictureStyle" @click="openImage(0)"></div>
      <div class="rp-images" v-if="pushedImages" :class="{'max-reached': this.embedPictures.length === this.sliceIndex}">
        <div
            v-for="(item, index) in pushedImages" :item="item" :key="item.src" :index="index"
            :data-nb="embedPictures.length - pushedImages.length"
            class="rm-image-item"
            @click="openImage(index)"
            :style="{
              width: 119*item.ratio + 'px',
              height: 119 + 'px',
              backgroundImage: `url('${cdnPath(item.src, {h: 119*3, w: 119*item.ratio*3})}')`
            }"
        >
          <template v-if="index === pushedImages.length - 1">
            <span v-if="embedPictures.length - pushedImages.length === 1">
              {{$t('room.otherPhoto', embedPictures.length - pushedImages.length)}}
            </span>
            <span v-else-if="embedPictures.length - pushedImages.length > 1">
              {{$t('room.otherPhotos', embedPictures.length - pushedImages.length)}}
            </span>
          </template>
        </div>
      </div>
    </div>
    <RpModal />
  </div>
</template>

<script>
import {mapState} from "vuex";
import {cdnPath} from "../../../helpers/cdn-helper";
import RpModal from "./RpModal";

export default {
  name: "RoomHeaderPictures",
  components: {RpModal},
  data () {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      mainPictureStyle: {},
      embedPictures: [],
      pushedImages: [],
      sliceIndex: -1,
      cdnPath: cdnPath
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      this.updateStyle();
    })
  },
  beforeDestroy() {
    this.embedPictures = [];
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize (event) {
      this.width = window.innerWidth;
      this.height = window.innerHeight - 190 - 86;
      const useHeight = 119;
      const ratioCount = this.width / useHeight;
      const marginRatio = 10 / useHeight;

      const currentSize = this.pushedImages.reduce((p,n) => (p + n.ratio + marginRatio), 2*marginRatio);
      if (currentSize > ratioCount) {
        this.sliceIndex = this.sliceIndex - 1;
      } else if (currentSize < ratioCount
          && this.pushedImages.length !== this.embedPictures.length
          && this.embedPictures.slice(this.sliceIndex, this.sliceIndex+1)[0].ratio + marginRatio + currentSize < ratioCount
      ) {
        this.sliceIndex = this.sliceIndex + 1;
      }
    },
    async updateStyle () {
      const path = cdnPath(this.pictures[0], {w: this.width, h: this.height, "crop-to-fit": 1});
      this.mainPictureStyle = {
        backgroundImage: `url("${path}")`
      }
      const tmpArray = [];
      for (const picture of this.pictures) {
        let img = document.createElement('img');
        img.src = cdnPath(picture, {q: .1});
        await (new Promise((resolve, reject) => {
          img.onload = () => {
            tmpArray.push({
              ratio: img.naturalWidth/img.naturalHeight,
              src: picture
            });
            img = null;
            resolve();
          }
          img.onerror = () => {
            img = null;
            resolve();
          }
        }))
      }
      this.$store.commit('room/SET_MODAL_SLIDER_PICTURES', tmpArray);
      const useHeight = 119;
      const ratioCount = this.width / useHeight;
      const marginRatio = 10 / useHeight;

      const exp = tmpArray.reduce((p, n) => {
        if (p.length === 0) return [n.ratio + marginRatio + marginRatio];
        p.push(p[p.length-1] + n.ratio + marginRatio);
        return p;
      }, [])
      let found = false;
      exp.forEach((item, index) => {
        if (!found && item > ratioCount) {
          found = true;
          this.sliceIndex = index;
        }
      })
      if (!found) {
        this.sliceIndex = tmpArray.length;
      }
      this.embedPictures = [...tmpArray];
    },
    buildPushedImages () {
      if (!this.embedPictures) {
        this.pushedImages = [];
        return;
      }
      this.pushedImages = this.embedPictures.slice(0, this.sliceIndex);
    },
    openImage (index) {
      this.$store.commit('room/SET_MODAL_SLIDER_INDEX', index);
      this.$store.commit('room/SET_MODAL_SLIDER', true);
    }
  },
  watch: {
    pictures (v) {
      if (this.pictures.length > 0) {
        this.updateStyle();
      }
    },
    sliceIndex (v) {
      this.buildPushedImages();
    },
    embedPictures () {
      this.buildPushedImages();
    }
  },
  computed: {
    ...mapState({
      pictures: s => s.room.room.pictures.map(r => `${r.absolute_path}`),
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/rooms/components/RoomHeaderPictures.vue